import request from '@/utils/request'

// 获取事件源设置 设置 列表
export const getEventSourceSettingLists = (data) => {
    return request({
        url: '/event/source/setting/setting/lists',
        params: data
    })
}

// 获取事件源设置选项列表
export const getEventSourceSettingOptionLists = (data) => {
    return request({
        url: '/event/source/setting/option/lists',
        params: data
    })
}

// 事件源设置-详情
export const getEventSourceSettingDetail = (id) => {
    return request({
        url: `/event/source/setting/${id}`
    })
}

// 事件源设置-修改
export const putEventSourceSetting = (data) => {
    return request({
        url: '/event/source/setting/manage',
        method: 'PUT',
        data
    })
}

// 事件源设置-添加
export const addEventSourceSetting = (data) => {
    return request({
        url: '/event/source/setting/manage',
        method: 'POST',
        data
    })
}

// 事件源设置-删除
export const delEventSourceSetting = (id) => {
    return request({
        url: `/event/source/setting/${id}`,
        method: 'DELETE'
    })
}

/**
 * 摄像头选项-能力级&摄像头类型
 */
export const getCapabilityCameraType = () => {
    return request({
        url: '/camera/options'
    })
}
